/*
 * Marketplace specific configuration.
 */
import Icon_Accounting from './assets/services/icon_accounting.svg';
import Icon_Business from './assets/services/icon_business.svg';
import Icon_Career from './assets/services/icon_career.svg';
import Icon_Confidence from './assets/services/icon_confidence.svg';
import Icon_EnergyWork from './assets/services/icon_energy_work.svg';
import Icon_Executive from './assets/services/icon_executive.svg';
import Icon_Finance from './assets/services/icon_finance.svg';
import Icon_Fitness from './assets/services/icon_fitness.svg';
import Icon_Health from './assets/services/icon_health.svg';
import Icon_IntuitiveHealing from './assets/services/icon_intuitive_healing.svg';
import Icon_Leadership from './assets/services/icon_leadership.svg';
import Icon_Life from './assets/services/icon_life.svg';
import Icon_Marketing from './assets/services/icon_marketing.svg';
import Icon_Nutrition from './assets/services/icon_nutrition.svg';
import Icon_Relationship from './assets/services/icon_relationship.svg';
import Icon_Sales from './assets/services/icon_sales.svg';
import Icon_Spiritual from './assets/services/icon_spiritual.svg';
import Icon_Strategy from './assets/services/icon_strategy.svg';
import Icon_Technology from './assets/services/icon_technology.svg';
import Icon_Wellness from './assets/services/icon_wellness.svg';

import Slide_Accounting from './assets/services/accounting.jpg';
import Slide_Confidence from './assets/services/confidence.png';
import Slide_Energy from './assets/services/energy.png';
import Slide_Fitness from './assets/services/fitness.png';
import Slide_Health from './assets/services/health.png';
import Slide_Inspiration from './assets/services/inspiration.png';
import Slide_Marketing from './assets/services/marketing.png';
import Slide_Motivation from './assets/services/motivation.png';
import Slide_Nutrition from './assets/services/nutrition.png';
import Slide_Transformational from './assets/services/transformational.png';
import Slide_Wellness from './assets/services/wellness.png';

import Icon_CoachLife from './assets/viveka/icons/CoachLife_logo.png';
import Icon_Forbes from './assets/viveka/icons/Forbes_logo.png';
import Icon_LaunchFestival from './assets/viveka/icons/LaunchFesti_logo.png';
import Icon_Startcon from './assets/viveka/icons/Startcon_logo.png';
import Icon_Engagement from './assets/viveka/icons/engagement-multiplier_logo.png';
import Icon_Motivation from './assets/viveka/icons/motivating_logo.png';
import Icon_Yahoo from './assets/viveka/icons/yahoo_logo.png';
import Icon_SBDC from './assets/viveka/icons/SBDC.png';
import Icon_TATA from './assets/viveka/icons/Tata.png';

import Business1 from './assets/services/business-1.jpg';
import Finance1 from './assets/services/finance.png';
import Leadership1 from './assets/services/leadership-1.jpg';
import Health1 from './assets/services/health-1.jpg';
import Marketing1 from './assets/services/marketing-1.jpg';
import Motivation1 from './assets/services/motivation-1.jpg';

export const amenities = [
  {
    key: 'towels',
    label: 'Towels',
  },
  {
    key: 'bathroom',
    label: 'Bathroom',
  },
  {
    key: 'swimming_pool',
    label: 'Swimming pool',
  },
  {
    key: 'own_drinks',
    label: 'Own drinks allowed',
  },
  {
    key: 'jacuzzi',
    label: 'Jacuzzi',
  },
  {
    key: 'audiovisual_entertainment',
    label: 'Audiovisual entertainment',
  },
  {
    key: 'barbeque',
    label: 'Barbeque',
  },
  {
    key: 'own_food_allowed',
    label: 'Own food allowed',
  },
];

export const languages = [
  { key: 'Afrikaans', label: 'Afrikaans' },
  { key: 'Arabic', label: 'Arabic' },
  { key: 'Bengali', label: 'Bengali' },
  { key: 'Bulgarian', label: 'Bulgarian' },
  { key: 'Cantonese', label: 'Cantonese' },
  { key: 'Chinese (Mandarin)', label: 'Chinese (Mandarin)' },
  { key: 'Croatian', label: 'Croatian' },
  { key: 'Czech', label: 'Czech' },
  { key: 'Danish', label: 'Danish' },
  { key: 'Dutch', label: 'Dutch' },
  { key: 'English', label: 'English' },
  { key: 'Filipino (Tagalog)', label: 'Filipino (Tagalog)' },
  { key: 'Finnish', label: 'Finnish' },
  { key: 'French', label: 'French' },
  { key: 'German', label: 'German' },
  { key: 'Greek', label: 'Greek' },
  { key: 'Gujarati', label: 'Gujarati' },
  { key: 'Hebrew', label: 'Hebrew' },
  { key: 'Hindi', label: 'Hindi' },
  { key: 'Hungarian', label: 'Hungarian' },
  { key: 'Indonesian', label: 'Indonesian' },
  { key: 'Italian', label: 'Italian' },
  { key: 'Japanese', label: 'Japanese' },
  { key: 'Kannada', label: 'Kannada' },
  { key: 'Korean', label: 'Korean' },
  { key: 'Lithuanian', label: 'Lithuanian' },
  { key: 'Latvian', label: 'Latvian' },
  { key: 'Malay', label: 'Malay' },
  { key: 'Malayalam', label: 'Malayalam' },
  { key: 'Marathi', label: 'Marathi' },
  { key: 'Norwegian', label: 'Norwegian' },
  { key: 'Persian (Farsi)', label: 'Persian (Farsi)' },
  { key: 'Polish', label: 'Polish' },
  { key: 'Portuguese', label: 'Portuguese' },
  { key: 'Punjabi', label: 'Punjabi' },
  { key: 'Romanian', label: 'Romanian' },
  { key: 'Russian', label: 'Russian' },
  { key: 'Serbian', label: 'Serbian' },
  { key: 'Slovak', label: 'Slovak' },
  { key: 'Slovenian', label: 'Slovenian' },
  { key: 'Spanish', label: 'Spanish' },
  { key: 'Swahili', label: 'Swahili' },
  { key: 'Swedish', label: 'Swedish' },
  { key: 'Tamil', label: 'Tamil' },
  { key: 'Telugu', label: 'Telugu' },
  { key: 'Thai', label: 'Thai' },
  { key: 'Turkish', label: 'Turkish' },
  { key: 'Ukrainian', label: 'Ukrainian' },
  { key: 'Urdu', label: 'Urdu' },
  { key: 'Vietnamese', label: 'Vietnamese' },
];

export const locations = [
  {
    key: 'Americas',
    label: 'Americas',
  },
  {
    key: 'Europe',
    label: 'Europe',
  },
  {
    key: 'Africa',
    label: 'Africa',
  },
  {
    key: 'Asia',
    label: 'Asia',
  },
  {
    key: 'Australia',
    label: 'Australia',
  },
];

export const services = [
  {
    key: 'Accounting',
    label: 'Accounting',
    image: Icon_Accounting,
  },
  {
    key: 'Business',
    label: 'Business',
    image: Icon_Business,
  },
  {
    key: 'Career',
    label: 'Career',
    image: Icon_Career,
  },
  {
    key: 'Confidence',
    label: 'Confidence',
    image: Icon_Confidence,
  },
  {
    key: 'Energy Work',
    label: 'Energy Work',
    image: Icon_EnergyWork,
  },
  {
    key: 'Executive',
    label: 'Executive',
    image: Icon_Executive,
  },
  {
    key: 'Fitness',
    label: 'Fitness',
    image: Icon_Fitness,
  },
  {
    key: 'Finance',
    label: 'Finance',
    image: Icon_Finance,
  },
  {
    key: 'Health',
    label: 'Health',
    image: Icon_Health,
  },
  {
    key: 'Intuitive Healing',
    label: 'Intuitive Healing',
    image: Icon_IntuitiveHealing,
  },
  {
    key: 'Leadership',
    label: 'Leadership',
    image: Icon_Leadership,
  },
  {
    key: 'Life',
    label: 'Life',
    image: Icon_Life,
  },
  {
    key: 'Marketing',
    label: 'Marketing',
    image: Icon_Marketing,
  },
  {
    key: 'Nutrition',
    label: 'Nutrition',
    image: Icon_Nutrition,
  },
  {
    key: 'Relationship',
    label: 'Relationship',
    image: Icon_Relationship,
  },
  {
    key: 'Sales',
    label: 'Sales',
    image: Icon_Sales,
  },
  {
    key: 'Spiritual',
    label: 'Spiritual',
    image: Icon_Spiritual,
  },
  {
    key: 'Strategy',
    label: 'Strategy',
    image: Icon_Strategy,
  },
  {
    key: 'Technology',
    label: 'Technology',
    image: Icon_Technology,
  },
  {
    key: 'Wellness',
    label: 'Wellness',
    image: Icon_Wellness,
  },
];

export const coachingSpecialties = [
  { key: "Executive & Leadership Coaching", label: "Executive & Leadership Coaching" },
  { key: "Executive Coaching", label: "Executive Coaching" },
  { key: "CEO Coaching", label: "CEO Coaching" },
  { key: "C-Suite Coaching", label: "C-Suite Coaching" },
  { key: "Senior Leadership Coaching", label: "Senior Leadership Coaching" },
  { key: "Leadership Coaching", label: "Leadership Coaching" },
  { key: "Leadership Development", label: "Leadership Development" },
  { key: "Executive Development", label: "Executive Development" },
  { key: "Emerging Leaders", label: "Emerging Leaders" },
  { key: "First-Time Leaders", label: "First-Time Leaders" },
  { key: "New Manager Coaching", label: "New Manager Coaching" },
  { key: "Middle Management", label: "Middle Management" },
  { key: "Senior Management", label: "Senior Management" },
  { key: "Leadership Transitions", label: "Leadership Transitions" },
  { key: "Executive Transitions", label: "Executive Transitions" },
  { key: "Leadership Acceleration", label: "Leadership Acceleration" },
  { key: "Leadership Effectiveness", label: "Leadership Effectiveness" },
  { key: "Leadership Excellence", label: "Leadership Excellence" },
  { key: "Leadership Performance", label: "Leadership Performance" },
  { key: "Leadership Potential", label: "Leadership Potential" },
  { key: "Leadership Identity", label: "Leadership Identity" },
  { key: "Leadership Mindset", label: "Leadership Mindset" },
  { key: "Leadership Confidence", label: "Leadership Confidence" },
  { key: "Leadership Agility", label: "Leadership Agility" },
  { key: "Leadership Resilience", label: "Leadership Resilience" },
  { key: "Leadership Presence", label: "Leadership Presence" },
  { key: "Executive Presence", label: "Executive Presence" },
  { key: "Executive Influence", label: "Executive Influence" },
  { key: "Executive Communication", label: "Executive Communication" },
  { key: "Executive Decision-Making", label: "Executive Decision-Making" },
  { key: "Strategic Leadership", label: "Strategic Leadership" },
  { key: "Visionary Leadership", label: "Visionary Leadership" },
  { key: "Transformational Leadership", label: "Transformational Leadership" },
  { key: "Authentic Leadership", label: "Authentic Leadership" },
  { key: "Conscious Leadership", label: "Conscious Leadership" },
  { key: "Servant Leadership", label: "Servant Leadership" },
  { key: "Inclusive Leadership", label: "Inclusive Leadership" },
  { key: "Adaptive Leadership", label: "Adaptive Leadership" },
  { key: "Collaborative Leadership", label: "Collaborative Leadership" },
  { key: "Compassionate Leadership", label: "Compassionate Leadership" },
  { key: "Courageous Leadership", label: "Courageous Leadership" },
  { key: "Ethical Leadership", label: "Ethical Leadership" },
  { key: "Purpose-Driven Leadership", label: "Purpose-Driven Leadership" },
  { key: "Values-Based Leadership", label: "Values-Based Leadership" },
  { key: "Global Leadership", label: "Global Leadership" },
  { key: "Cross-Cultural Leadership", label: "Cross-Cultural Leadership" },
  { key: "Remote Leadership", label: "Remote Leadership" },
  { key: "Hybrid Leadership", label: "Hybrid Leadership" },
  { key: "Women in Leadership", label: "Women in Leadership" },
  { key: "Female Leadership", label: "Female Leadership" },
  { key: "Men in Leadership", label: "Men in Leadership" },
  { key: "Young Leaders", label: "Young Leaders" },
  { key: "Next-Generation Leadership", label: "Next-Generation Leadership" },
  { key: "Strategy & Executive Effectiveness", label: "Strategy & Executive Effectiveness" },
  { key: "Strategic Thinking", label: "Strategic Thinking" },
  { key: "Strategic Planning", label: "Strategic Planning" },
  { key: "Strategic Execution", label: "Strategic Execution" },
  { key: "Vision Development", label: "Vision Development" },
  { key: "Mission Development", label: "Mission Development" },
  { key: "Decision-Making", label: "Decision-Making" },
  { key: "Critical Thinking", label: "Critical Thinking" },
  { key: "Systems Thinking", label: "Systems Thinking" },
  { key: "Problem Solving", label: "Problem Solving" },
  { key: "Prioritization", label: "Prioritization" },
  { key: "Accountability", label: "Accountability" },
  { key: "Delegation", label: "Delegation" },
  { key: "Executive Productivity", label: "Executive Productivity" },
  { key: "Time Management", label: "Time Management" },
  { key: "Focus", label: "Focus" },
  { key: "Goal Setting", label: "Goal Setting" },
  { key: "Goal Achievement", label: "Goal Achievement" },
  { key: "Performance Management", label: "Performance Management" },
  { key: "Personal Effectiveness", label: "Personal Effectiveness" },
  { key: "Executive Effectiveness", label: "Executive Effectiveness" },
  { key: "Stakeholder Management", label: "Stakeholder Management" },
  { key: "Stakeholder Influence", label: "Stakeholder Influence" },
  { key: "Managing Up", label: "Managing Up" },
  { key: "Influence", label: "Influence" },
  { key: "Persuasion", label: "Persuasion" },
  { key: "Negotiation", label: "Negotiation" },
  { key: "Executive Storytelling", label: "Executive Storytelling" },
  { key: "Presentation Skills", label: "Presentation Skills" },
  { key: "Public Speaking", label: "Public Speaking" },
  { key: "Communication", label: "Communication" },
  { key: "Leadership Communication", label: "Leadership Communication" },
  { key: "Difficult Conversations", label: "Difficult Conversations" },
  { key: "Crucial Conversations", label: "Crucial Conversations" },
  { key: "Feedback", label: "Feedback" },
  { key: "Active Listening", label: "Active Listening" },
  { key: "Interpersonal Skills", label: "Interpersonal Skills" },
  { key: "Teams", label: "Teams" },
  { key: "Team Coaching", label: "Team Coaching" },
  { key: "Team Development", label: "Team Development" },
  { key: "Team Effectiveness", label: "Team Effectiveness" },
  { key: "Team Performance", label: "Team Performance" },
  { key: "High-Performing Teams", label: "High-Performing Teams" },
  { key: "Team Alignment", label: "Team Alignment" },
  { key: "Team Dynamics", label: "Team Dynamics" },
  { key: "Team Building", label: "Team Building" },
  { key: "Team Communication", label: "Team Communication" },
  { key: "Team Collaboration", label: "Team Collaboration" },
  { key: "Team Trust", label: "Team Trust" },
  { key: "Psychological Safety", label: "Psychological Safety" },
  { key: "Team Accountability", label: "Team Accountability" },
  { key: "Team Resilience", label: "Team Resilience" },
  { key: "Team Conflict", label: "Team Conflict" },
  { key: "Conflict Resolution", label: "Conflict Resolution" },
  { key: "Conflict Management", label: "Conflict Management" },
  { key: "Collaboration", label: "Collaboration" },
  { key: "Cross-Functional Collaboration", label: "Cross-Functional Collaboration" },
  { key: "Virtual Teams", label: "Virtual Teams" },
  { key: "Remote Teams", label: "Remote Teams" },
  { key: "Hybrid Teams", label: "Hybrid Teams" },
  { key: "Multicultural Teams", label: "Multicultural Teams" },
  { key: "Executive Teams", label: "Executive Teams" },
  { key: "Leadership Teams", label: "Leadership Teams" },
  { key: "Senior Leadership Teams", label: "Senior Leadership Teams" },
  { key: "Organizations & Culture", label: "Organizations & Culture" },
  { key: "Organizational Development", label: "Organizational Development" },
  { key: "Organizational Effectiveness", label: "Organizational Effectiveness" },
  { key: "Organizational Transformation", label: "Organizational Transformation" },
  { key: "Organizational Change", label: "Organizational Change" },
  { key: "Change Management", label: "Change Management" },
  { key: "Change Leadership", label: "Change Leadership" },
  { key: "Transformation", label: "Transformation" },
  { key: "Culture", label: "Culture" },
  { key: "Culture Transformation", label: "Culture Transformation" },
  { key: "Organizational Culture", label: "Organizational Culture" },
  { key: "Workplace Culture", label: "Workplace Culture" },
  { key: "High-Performance Culture", label: "High-Performance Culture" },
  { key: "Values Alignment", label: "Values Alignment" },
  { key: "Employee Experience", label: "Employee Experience" },
  { key: "Employee Engagement", label: "Employee Engagement" },
  { key: "Employee Retention", label: "Employee Retention" },
  { key: "Talent Retention", label: "Talent Retention" },
  { key: "Talent Development", label: "Talent Development" },
  { key: "Talent Management", label: "Talent Management" },
  { key: "Leadership Pipeline", label: "Leadership Pipeline" },
  { key: "Succession Planning", label: "Succession Planning" },
  { key: "Workforce Development", label: "Workforce Development" },
  { key: "Workforce Transformation", label: "Workforce Transformation" },
  { key: "Future of Work", label: "Future of Work" },
  { key: "Organizational Design", label: "Organizational Design" },
  { key: "Operating Models", label: "Operating Models" },
  { key: "Organizational Agility", label: "Organizational Agility" },
  { key: "Learning Culture", label: "Learning Culture" },
  { key: "Coaching Culture", label: "Coaching Culture" },
  { key: "Innovation Culture", label: "Innovation Culture" },
  { key: "Culture Integration", label: "Culture Integration" },
  { key: "Post-Merger Integration", label: "Post-Merger Integration" },
  { key: "People, HR & Inclusion", label: "People, HR & Inclusion" },
  { key: "Human Resources", label: "Human Resources" },
  { key: "People Strategy", label: "People Strategy" },
  { key: "People Leadership", label: "People Leadership" },
  { key: "HR Leadership", label: "HR Leadership" },
  { key: "HR Transformation", label: "HR Transformation" },
  { key: "Learning & Development", label: "Learning & Development" },
  { key: "Learning Strategy", label: "Learning Strategy" },
  { key: "Leadership Assessment", label: "Leadership Assessment" },
  { key: "360 Feedback", label: "360 Feedback" },
  { key: "Executive Assessment", label: "Executive Assessment" },
  { key: "Competency Development", label: "Competency Development" },
  { key: "Performance Reviews", label: "Performance Reviews" },
  { key: "DEI", label: "DEI" },
  { key: "Diversity", label: "Diversity" },
  { key: "Equity", label: "Equity" },
  { key: "Inclusion", label: "Inclusion" },
  { key: "Belonging", label: "Belonging" },
  { key: "Inclusive Workplace", label: "Inclusive Workplace" },
  { key: "Accessibility", label: "Accessibility" },
  { key: "Neuroinclusion", label: "Neuroinclusion" },
  { key: "Neurodiversity", label: "Neurodiversity" },
  { key: "Unconscious Bias", label: "Unconscious Bias" },
  { key: "Allyship", label: "Allyship" },
  { key: "Gender Equity", label: "Gender Equity" },
  { key: "Cultural Intelligence", label: "Cultural Intelligence" },
  { key: "Cross-Cultural Communication", label: "Cross-Cultural Communication" },
  { key: "Intergenerational Leadership", label: "Intergenerational Leadership" },
  { key: "Multigenerational Workforce", label: "Multigenerational Workforce" },
  { key: "Boards & Governance", label: "Boards & Governance" },
  { key: "Board Coaching", label: "Board Coaching" },
  { key: "Board Development", label: "Board Development" },
  { key: "Board Effectiveness", label: "Board Effectiveness" },
  { key: "Board Leadership", label: "Board Leadership" },
  { key: "Board Governance", label: "Board Governance" },
  { key: "Board Readiness", label: "Board Readiness" },
  { key: "Board Career Strategy", label: "Board Career Strategy" },
  { key: "Advisory Boards", label: "Advisory Boards" },
  { key: "Corporate Governance", label: "Corporate Governance" },
  { key: "Governance", label: "Governance" },
  { key: "Chairman Coaching", label: "Chairman Coaching" },
  { key: "Nonprofit Leadership", label: "Nonprofit Leadership" },
  { key: "Nonprofit Boards", label: "Nonprofit Boards" },
  { key: "High-Stakes Leadership", label: "High-Stakes Leadership" },
  { key: "Crisis Leadership", label: "Crisis Leadership" },
  { key: "Crisis Management", label: "Crisis Management" },
  { key: "Leadership Under Pressure", label: "Leadership Under Pressure" },
  { key: "High-Stakes Decision-Making", label: "High-Stakes Decision-Making" },
  { key: "Complexity", label: "Complexity" },
  { key: "Uncertainty", label: "Uncertainty" },
  { key: "Leading Through Change", label: "Leading Through Change" },
  { key: "Leading Through Growth", label: "Leading Through Growth" },
  { key: "Leading Through Restructuring", label: "Leading Through Restructuring" },
  { key: "Merger Integration", label: "Merger Integration" },
  { key: "Turnaround Leadership", label: "Turnaround Leadership" },
  { key: "Reputation Leadership", label: "Reputation Leadership" },
  { key: "Business & Entrepreneurship", label: "Business & Entrepreneurship" },
  { key: "Business Coaching", label: "Business Coaching" },
  { key: "Business Strategy", label: "Business Strategy" },
  { key: "Business Consulting", label: "Business Consulting" },
  { key: "Business Advisory", label: "Business Advisory" },
  { key: "Entrepreneurship", label: "Entrepreneurship" },
  { key: "Entrepreneur Coaching", label: "Entrepreneur Coaching" },
  { key: "Founder Coaching", label: "Founder Coaching" },
  { key: "Founder Development", label: "Founder Development" },
  { key: "Founder Well-being", label: "Founder Well-being" },
  { key: "Startup Coaching", label: "Startup Coaching" },
  { key: "Startup Strategy", label: "Startup Strategy" },
  { key: "Small Business Coaching", label: "Small Business Coaching" },
  { key: "SME Coaching", label: "SME Coaching" },
  { key: "Solopreneur Coaching", label: "Solopreneur Coaching" },
  { key: "Scale-Up Coaching", label: "Scale-Up Coaching" },
  { key: "Scaling a Business", label: "Scaling a Business" },
  { key: "Business Growth", label: "Business Growth" },
  { key: "Growth Strategy", label: "Growth Strategy" },
  { key: "Growth Planning", label: "Growth Planning" },
  { key: "Business Transformation", label: "Business Transformation" },
  { key: "Business Model", label: "Business Model" },
  { key: "Business Model Innovation", label: "Business Model Innovation" },
  { key: "Business Planning", label: "Business Planning" },
  { key: "Competitive Strategy", label: "Competitive Strategy" },
  { key: "Market Strategy", label: "Market Strategy" },
  { key: "Go-to-Market Strategy", label: "Go-to-Market Strategy" },
  { key: "Market Expansion", label: "Market Expansion" },
  { key: "International Expansion", label: "International Expansion" },
  { key: "Global Business", label: "Global Business" },
  { key: "Partnerships", label: "Partnerships" },
  { key: "Strategic Partnerships", label: "Strategic Partnerships" },
  { key: "Joint Ventures", label: "Joint Ventures" },
  { key: "Ecosystem Strategy", label: "Ecosystem Strategy" },
  { key: "Franchise Strategy", label: "Franchise Strategy" },
  { key: "Exit Strategy", label: "Exit Strategy" },
  { key: "Business Succession", label: "Business Succession" },
  { key: "Family Business", label: "Family Business" },
  { key: "Family Enterprise", label: "Family Enterprise" },
  { key: "Sales & Revenue", label: "Sales & Revenue" },
  { key: "Sales", label: "Sales" },
  { key: "Sales Coaching", label: "Sales Coaching" },
  { key: "Sales Strategy", label: "Sales Strategy" },
  { key: "Sales Leadership", label: "Sales Leadership" },
  { key: "Sales Management", label: "Sales Management" },
  { key: "B2B Sales", label: "B2B Sales" },
  { key: "B2C Sales", label: "B2C Sales" },
  { key: "Enterprise Sales", label: "Enterprise Sales" },
  { key: "Consultative Selling", label: "Consultative Selling" },
  { key: "Relationship Selling", label: "Relationship Selling" },
  { key: "Social Selling", label: "Social Selling" },
  { key: "Sales Enablement", label: "Sales Enablement" },
  { key: "Sales Performance", label: "Sales Performance" },
  { key: "Sales Process", label: "Sales Process" },
  { key: "Sales Pipeline", label: "Sales Pipeline" },
  { key: "Lead Generation", label: "Lead Generation" },
  { key: "Prospecting", label: "Prospecting" },
  { key: "Closing", label: "Closing" },
  { key: "Revenue Growth", label: "Revenue Growth" },
  { key: "Revenue Strategy", label: "Revenue Strategy" },
  { key: "Revenue Operations", label: "Revenue Operations" },
  { key: "Pricing Strategy", label: "Pricing Strategy" },
  { key: "Monetization", label: "Monetization" },
  { key: "Recurring Revenue", label: "Recurring Revenue" },
  { key: "Subscription Business", label: "Subscription Business" },
  { key: "Customer Acquisition", label: "Customer Acquisition" },
  { key: "Customer Retention", label: "Customer Retention" },
  { key: "Customer Success", label: "Customer Success" },
  { key: "Account Management", label: "Account Management" },
  { key: "Key Account Management", label: "Key Account Management" },
  { key: "Marketing & Brand", label: "Marketing & Brand" },
  { key: "Marketing", label: "Marketing" },
  { key: "Marketing Strategy", label: "Marketing Strategy" },
  { key: "Digital Marketing", label: "Digital Marketing" },
  { key: "Content Marketing", label: "Content Marketing" },
  { key: "Social Media Marketing", label: "Social Media Marketing" },
  { key: "Email Marketing", label: "Email Marketing" },
  { key: "Search Marketing", label: "Search Marketing" },
  { key: "SEO", label: "SEO" },
  { key: "Paid Advertising", label: "Paid Advertising" },
  { key: "Performance Marketing", label: "Performance Marketing" },
  { key: "Growth Marketing", label: "Growth Marketing" },
  { key: "Demand Generation", label: "Demand Generation" },
  { key: "Brand Strategy", label: "Brand Strategy" },
  { key: "Branding", label: "Branding" },
  { key: "Personal Branding", label: "Personal Branding" },
  { key: "Employer Branding", label: "Employer Branding" },
  { key: "Thought Leadership", label: "Thought Leadership" },
  { key: "Content Strategy", label: "Content Strategy" },
  { key: "Storytelling", label: "Storytelling" },
  { key: "Copywriting", label: "Copywriting" },
  { key: "Public Relations", label: "Public Relations" },
  { key: "Media Strategy", label: "Media Strategy" },
  { key: "Community Marketing", label: "Community Marketing" },
  { key: "Influencer Marketing", label: "Influencer Marketing" },
  { key: "Affiliate Marketing", label: "Affiliate Marketing" },
  { key: "Referral Marketing", label: "Referral Marketing" },
  { key: "Product Marketing", label: "Product Marketing" },
  { key: "Market Research", label: "Market Research" },
  { key: "Customer Insights", label: "Customer Insights" },
  { key: "Customer Experience", label: "Customer Experience" },
  { key: "Customer Journey", label: "Customer Journey" },
  { key: "Conversion Optimization", label: "Conversion Optimization" },
  { key: "Funnel Strategy", label: "Funnel Strategy" },
  { key: "Launch Strategy", label: "Launch Strategy" },
  { key: "Technology, Innovation & AI", label: "Technology, Innovation & AI" },
  { key: "Artificial Intelligence", label: "Artificial Intelligence" },
  { key: "Generative AI", label: "Generative AI" },
  { key: "AI Coaching", label: "AI Coaching" },
  { key: "AI Strategy", label: "AI Strategy" },
  { key: "AI Leadership", label: "AI Leadership" },
  { key: "AI Adoption", label: "AI Adoption" },
  { key: "AI Transformation", label: "AI Transformation" },
  { key: "AI for Business", label: "AI for Business" },
  { key: "AI Productivity", label: "AI Productivity" },
  { key: "AI Automation", label: "AI Automation" },
  { key: "Prompt Engineering", label: "Prompt Engineering" },
  { key: "Automation", label: "Automation" },
  { key: "Workflow Automation", label: "Workflow Automation" },
  { key: "Digital Transformation", label: "Digital Transformation" },
  { key: "Technology Strategy", label: "Technology Strategy" },
  { key: "Technology Leadership", label: "Technology Leadership" },
  { key: "Innovation", label: "Innovation" },
  { key: "Innovation Strategy", label: "Innovation Strategy" },
  { key: "Innovation Leadership", label: "Innovation Leadership" },
  { key: "Design Thinking", label: "Design Thinking" },
  { key: "Product Innovation", label: "Product Innovation" },
  { key: "Product Strategy", label: "Product Strategy" },
  { key: "Product Management", label: "Product Management" },
  { key: "Agile", label: "Agile" },
  { key: "Agile Leadership", label: "Agile Leadership" },
  { key: "Data Strategy", label: "Data Strategy" },
  { key: "Data-Driven Leadership", label: "Data-Driven Leadership" },
  { key: "Digital Leadership", label: "Digital Leadership" },
  { key: "Technology Adoption", label: "Technology Adoption" },
  { key: "Operations & Finance", label: "Operations & Finance" },
  { key: "Operations", label: "Operations" },
  { key: "Operations Strategy", label: "Operations Strategy" },
  { key: "Operational Excellence", label: "Operational Excellence" },
  { key: "Process Improvement", label: "Process Improvement" },
  { key: "Process Optimization", label: "Process Optimization" },
  { key: "Systems & Processes", label: "Systems & Processes" },
  { key: "Business Systems", label: "Business Systems" },
  { key: "Project Management", label: "Project Management" },
  { key: "Program Management", label: "Program Management" },
  { key: "Execution", label: "Execution" },
  { key: "Productivity", label: "Productivity" },
  { key: "Efficiency", label: "Efficiency" },
  { key: "Financial Coaching", label: "Financial Coaching" },
  { key: "Business Finance", label: "Business Finance" },
  { key: "Financial Strategy", label: "Financial Strategy" },
  { key: "Financial Literacy", label: "Financial Literacy" },
  { key: "Cash Flow", label: "Cash Flow" },
  { key: "Profitability", label: "Profitability" },
  { key: "Profit Growth", label: "Profit Growth" },
  { key: "Budgeting", label: "Budgeting" },
  { key: "Forecasting", label: "Forecasting" },
  { key: "Wealth Creation", label: "Wealth Creation" },
  { key: "Wealth Mindset", label: "Wealth Mindset" },
  { key: "Investment Readiness", label: "Investment Readiness" },
  { key: "Fundraising", label: "Fundraising" },
  { key: "Investor Readiness", label: "Investor Readiness" },
  { key: "Venture Capital", label: "Venture Capital" },
  { key: "Capital Raising", label: "Capital Raising" },
  { key: "Career & Professional Development", label: "Career & Professional Development" },
  { key: "Career Coaching", label: "Career Coaching" },
  { key: "Executive Career Coaching", label: "Executive Career Coaching" },
  { key: "Career Strategy", label: "Career Strategy" },
  { key: "Career Development", label: "Career Development" },
  { key: "Career Advancement", label: "Career Advancement" },
  { key: "Career Transition", label: "Career Transition" },
  { key: "Career Change", label: "Career Change" },
  { key: "Career Reinvention", label: "Career Reinvention" },
  { key: "Career Clarity", label: "Career Clarity" },
  { key: "Career Planning", label: "Career Planning" },
  { key: "Career Fulfillment", label: "Career Fulfillment" },
  { key: "Career Confidence", label: "Career Confidence" },
  { key: "Leadership Career Strategy", label: "Leadership Career Strategy" },
  { key: "Promotion Readiness", label: "Promotion Readiness" },
  { key: "Executive Promotion", label: "Executive Promotion" },
  { key: "Job Search", label: "Job Search" },
  { key: "Executive Job Search", label: "Executive Job Search" },
  { key: "Resume Development", label: "Resume Development" },
  { key: "CV Development", label: "CV Development" },
  { key: "LinkedIn Strategy", label: "LinkedIn Strategy" },
  { key: "Interview Preparation", label: "Interview Preparation" },
  { key: "Executive Interviews", label: "Executive Interviews" },
  { key: "Salary Negotiation", label: "Salary Negotiation" },
  { key: "Compensation Negotiation", label: "Compensation Negotiation" },
  { key: "Networking", label: "Networking" },
  { key: "Professional Networking", label: "Professional Networking" },
  { key: "Professional Development", label: "Professional Development" },
  { key: "Workplace Performance", label: "Workplace Performance" },
  { key: "Workplace Communication", label: "Workplace Communication" },
  { key: "Workplace Confidence", label: "Workplace Confidence" },
  { key: "Return to Work", label: "Return to Work" },
  { key: "Entrepreneurship Transition", label: "Entrepreneurship Transition" },
  { key: "Retirement Transition", label: "Retirement Transition" },
  { key: "Expat Coaching", label: "Expat Coaching" },
  { key: "Global Mobility", label: "Global Mobility" },
  { key: "Relocation Coaching", label: "Relocation Coaching" },
  { key: "Performance & Achievement", label: "Performance & Achievement" },
  { key: "Peak Performance", label: "Peak Performance" },
  { key: "High Performance", label: "High Performance" },
  { key: "Performance Coaching", label: "Performance Coaching" },
  { key: "Motivation", label: "Motivation" },
  { key: "Habit Formation", label: "Habit Formation" },
  { key: "Discipline", label: "Discipline" },
  { key: "Consistency", label: "Consistency" },
  { key: "Energy Management", label: "Energy Management" },
  { key: "Mental Performance", label: "Mental Performance" },
  { key: "Performance Mindset", label: "Performance Mindset" },
  { key: "Growth Mindset", label: "Growth Mindset" },
  { key: "Success Mindset", label: "Success Mindset" },
  { key: "Confidence", label: "Confidence" },
  { key: "Imposter Syndrome", label: "Imposter Syndrome" },
  { key: "Perfectionism", label: "Perfectionism" },
  { key: "Procrastination", label: "Procrastination" },
  { key: "Self-Leadership", label: "Self-Leadership" },
  { key: "Life & Personal Development", label: "Life & Personal Development" },
  { key: "Life Coaching", label: "Life Coaching" },
  { key: "Personal Coaching", label: "Personal Coaching" },
  { key: "Personal Development", label: "Personal Development" },
  { key: "Personal Growth", label: "Personal Growth" },
  { key: "Self-Development", label: "Self-Development" },
  { key: "Self-Discovery", label: "Self-Discovery" },
  { key: "Self-Awareness", label: "Self-Awareness" },
  { key: "Identity", label: "Identity" },
  { key: "Identity Development", label: "Identity Development" },
  { key: "Authenticity", label: "Authenticity" },
  { key: "Authentic Living", label: "Authentic Living" },
  { key: "Values", label: "Values" },
  { key: "Purpose", label: "Purpose" },
  { key: "Life Purpose", label: "Life Purpose" },
  { key: "Meaning", label: "Meaning" },
  { key: "Fulfillment", label: "Fulfillment" },
  { key: "Life Fulfillment", label: "Life Fulfillment" },
  { key: "Life Design", label: "Life Design" },
  { key: "Life Planning", label: "Life Planning" },
  { key: "Life Transitions", label: "Life Transitions" },
  { key: "Major Life Changes", label: "Major Life Changes" },
  { key: "Personal Transformation", label: "Personal Transformation" },
  { key: "Transformation Coaching", label: "Transformation Coaching" },
  { key: "Reinvention", label: "Reinvention" },
  { key: "Self-Confidence", label: "Self-Confidence" },
  { key: "Self-Esteem", label: "Self-Esteem" },
  { key: "Self-Worth", label: "Self-Worth" },
  { key: "Self-Acceptance", label: "Self-Acceptance" },
  { key: "Self-Compassion", label: "Self-Compassion" },
  { key: "Courage", label: "Courage" },
  { key: "Vulnerability", label: "Vulnerability" },
  { key: "Boundaries", label: "Boundaries" },
  { key: "Personal Boundaries", label: "Personal Boundaries" },
  { key: "People Pleasing", label: "People Pleasing" },
  { key: "Inner Critic", label: "Inner Critic" },
  { key: "Limiting Beliefs", label: "Limiting Beliefs" },
  { key: "Mindset", label: "Mindset" },
  { key: "Positive Psychology", label: "Positive Psychology" },
  { key: "Happiness", label: "Happiness" },
  { key: "Joy", label: "Joy" },
  { key: "Gratitude", label: "Gratitude" },
  { key: "Creativity", label: "Creativity" },
  { key: "Creative Coaching", label: "Creative Coaching" },
  { key: "Creative Expression", label: "Creative Expression" },
  { key: "Emotional & Mental Well-being", label: "Emotional & Mental Well-being" },
  { key: "Well-being", label: "Well-being" },
  { key: "Emotional Well-being", label: "Emotional Well-being" },
  { key: "Mental Well-being", label: "Mental Well-being" },
  { key: "Mental Fitness", label: "Mental Fitness" },
  { key: "Emotional Intelligence", label: "Emotional Intelligence" },
  { key: "Emotional Regulation", label: "Emotional Regulation" },
  { key: "Emotional Resilience", label: "Emotional Resilience" },
  { key: "Resilience", label: "Resilience" },
  { key: "Stress Management", label: "Stress Management" },
  { key: "Stress Reduction", label: "Stress Reduction" },
  { key: "Burnout Prevention", label: "Burnout Prevention" },
  { key: "Burnout Recovery", label: "Burnout Recovery" },
  { key: "Burnout Coaching", label: "Burnout Coaching" },
  { key: "Overwhelm", label: "Overwhelm" },
  { key: "Work-Life Balance", label: "Work-Life Balance" },
  { key: "Work-Life Integration", label: "Work-Life Integration" },
  { key: "Rest & Recovery", label: "Rest & Recovery" },
  { key: "Nervous System Regulation", label: "Nervous System Regulation" },
  { key: "Relaxation", label: "Relaxation" },
  { key: "Mindfulness", label: "Mindfulness" },
  { key: "Mindful Living", label: "Mindful Living" },
  { key: "Self-Care", label: "Self-Care" },
  { key: "Compassion", label: "Compassion" },
  { key: "Inner Peace", label: "Inner Peace" },
  { key: "Life Balance", label: "Life Balance" },
  { key: "Relationships, Family & Connection", label: "Relationships, Family & Connection" },
  { key: "Relationship Coaching", label: "Relationship Coaching" },
  { key: "Relationship Development", label: "Relationship Development" },
  { key: "Couples Coaching", label: "Couples Coaching" },
  { key: "Marriage Coaching", label: "Marriage Coaching" },
  { key: "Dating Coaching", label: "Dating Coaching" },
  { key: "Dating & Relationships", label: "Dating & Relationships" },
  { key: "Conscious Relationships", label: "Conscious Relationships" },
  { key: "Intimacy", label: "Intimacy" },
  { key: "Communication in Relationships", label: "Communication in Relationships" },
  { key: "Relationship Conflict", label: "Relationship Conflict" },
  { key: "Relationship Transitions", label: "Relationship Transitions" },
  { key: "Separation", label: "Separation" },
  { key: "Divorce Coaching", label: "Divorce Coaching" },
  { key: "Divorce Recovery", label: "Divorce Recovery" },
  { key: "Co-Parenting", label: "Co-Parenting" },
  { key: "Parenting", label: "Parenting" },
  { key: "Parenting Coaching", label: "Parenting Coaching" },
  { key: "Conscious Parenting", label: "Conscious Parenting" },
  { key: "New Parents", label: "New Parents" },
  { key: "Family Coaching", label: "Family Coaching" },
  { key: "Family Relationships", label: "Family Relationships" },
  { key: "Family Communication", label: "Family Communication" },
  { key: "Family Transitions", label: "Family Transitions" },
  { key: "Blended Families", label: "Blended Families" },
  { key: "Empty Nest", label: "Empty Nest" },
  { key: "Caregiving", label: "Caregiving" },
  { key: "Friendship", label: "Friendship" },
  { key: "Social Connection", label: "Social Connection" },
  { key: "Loneliness", label: "Loneliness" },
  { key: "Community & Belonging", label: "Community & Belonging" },
  { key: "Health & Lifestyle", label: "Health & Lifestyle" },
  { key: "Health Coaching", label: "Health Coaching" },
  { key: "Holistic Health", label: "Holistic Health" },
  { key: "Holistic Well-being", label: "Holistic Well-being" },
  { key: "Lifestyle Coaching", label: "Lifestyle Coaching" },
  { key: "Lifestyle Medicine Support", label: "Lifestyle Medicine Support" },
  { key: "Nutrition", label: "Nutrition" },
  { key: "Nutrition Coaching", label: "Nutrition Coaching" },
  { key: "Healthy Eating", label: "Healthy Eating" },
  { key: "Mindful Eating", label: "Mindful Eating" },
  { key: "Healthy Habits", label: "Healthy Habits" },
  { key: "Habit Change", label: "Habit Change" },
  { key: "Fitness", label: "Fitness" },
  { key: "Fitness Coaching", label: "Fitness Coaching" },
  { key: "Movement", label: "Movement" },
  { key: "Exercise", label: "Exercise" },
  { key: "Strength & Conditioning", label: "Strength & Conditioning" },
  { key: "Mobility", label: "Mobility" },
  { key: "Sleep", label: "Sleep" },
  { key: "Sleep Coaching", label: "Sleep Coaching" },
  { key: "Rest", label: "Rest" },
  { key: "Recovery", label: "Recovery" },
  { key: "Longevity", label: "Longevity" },
  { key: "Healthy Aging", label: "Healthy Aging" },
  { key: "Vitality", label: "Vitality" },
  { key: "Energy", label: "Energy" },
  { key: "Women's Well-being", label: "Women's Well-being" },
  { key: "Men's Well-being", label: "Men's Well-being" },
  { key: "Workplace Well-being", label: "Workplace Well-being" },
  { key: "Corporate Well-being", label: "Corporate Well-being" },
  { key: "Women's & Men's Development", label: "Women's & Men's Development" },
  { key: "Women's Coaching", label: "Women's Coaching" },
  { key: "Women's Empowerment", label: "Women's Empowerment" },
  { key: "Women's Leadership", label: "Women's Leadership" },
  { key: "Female Entrepreneurship", label: "Female Entrepreneurship" },
  { key: "Motherhood", label: "Motherhood" },
  { key: "Working Mothers", label: "Working Mothers" },
  { key: "Menopause Support", label: "Menopause Support" },
  { key: "Midlife Women", label: "Midlife Women" },
  { key: "Men's Coaching", label: "Men's Coaching" },
  { key: "Men's Development", label: "Men's Development" },
  { key: "Fatherhood", label: "Fatherhood" },
  { key: "Masculinity", label: "Masculinity" },
  { key: "Conscious Masculinity", label: "Conscious Masculinity" },
  { key: "Midlife Men", label: "Midlife Men" },
  { key: "Neurodiversity Coaching", label: "Neurodiversity Coaching" },
  { key: "Neurodivergent Professionals", label: "Neurodivergent Professionals" },
  { key: "ADHD Coaching", label: "ADHD Coaching" },
  { key: "ADHD at Work", label: "ADHD at Work" },
  { key: "Executive Functioning", label: "Executive Functioning" },
  { key: "Focus & Organization", label: "Focus & Organization" },
  { key: "Autism Coaching", label: "Autism Coaching" },
  { key: "Autistic Professionals", label: "Autistic Professionals" },
  { key: "Dyslexia Support", label: "Dyslexia Support" },
  { key: "Sensory Awareness", label: "Sensory Awareness" },
  { key: "Neurodivergent Leadership", label: "Neurodivergent Leadership" },
  { key: "Neurodivergent Entrepreneurs", label: "Neurodivergent Entrepreneurs" },
  { key: "Grief, Change & Difficult Life Experiences", label: "Grief, Change & Difficult Life Experiences" },
  { key: "Grief", label: "Grief" },
  { key: "Grief Coaching", label: "Grief Coaching" },
  { key: "Loss", label: "Loss" },
  { key: "Bereavement", label: "Bereavement" },
  { key: "Life After Loss", label: "Life After Loss" },
  { key: "Anticipatory Grief", label: "Anticipatory Grief" },
  { key: "Breakup Recovery", label: "Breakup Recovery" },
  { key: "Major Life Transition", label: "Major Life Transition" },
  { key: "Caregiver Support", label: "Caregiver Support" },
  { key: "Resilience After Adversity", label: "Resilience After Adversity" },
  { key: "Post-Adversity Growth", label: "Post-Adversity Growth" },
  { key: "Forgiveness", label: "Forgiveness" },
  { key: "Letting Go", label: "Letting Go" },
  { key: "Acceptance", label: "Acceptance" },
  { key: "End-of-Life Coaching", label: "End-of-Life Coaching" },
  { key: "Legacy", label: "Legacy" },
  { key: "Legacy Planning", label: "Legacy Planning" },
  { key: "Spiritual Development", label: "Spiritual Development" },
  { key: "Spiritual Coaching", label: "Spiritual Coaching" },
  { key: "Spirituality", label: "Spirituality" },
  { key: "Spiritual Growth", label: "Spiritual Growth" },
  { key: "Spiritual Awakening", label: "Spiritual Awakening" },
  { key: "Consciousness", label: "Consciousness" },
  { key: "Conscious Living", label: "Conscious Living" },
  { key: "Consciousness Coaching", label: "Consciousness Coaching" },
  { key: "Higher Consciousness", label: "Higher Consciousness" },
  { key: "Self-Realization", label: "Self-Realization" },
  { key: "Inner Work", label: "Inner Work" },
  { key: "Inner Transformation", label: "Inner Transformation" },
  { key: "Soul Purpose", label: "Soul Purpose" },
  { key: "Soul Coaching", label: "Soul Coaching" },
  { key: "Soul Alignment", label: "Soul Alignment" },
  { key: "Sacred Living", label: "Sacred Living" },
  { key: "Sacred Leadership", label: "Sacred Leadership" },
  { key: "Intuition", label: "Intuition" },
  { key: "Intuitive Development", label: "Intuitive Development" },
  { key: "Intuitive Coaching", label: "Intuitive Coaching" },
  { key: "Inner Guidance", label: "Inner Guidance" },
  { key: "Divine Feminine", label: "Divine Feminine" },
  { key: "Divine Masculine", label: "Divine Masculine" },
  { key: "Sacred Feminine", label: "Sacred Feminine" },
  { key: "Sacred Masculine", label: "Sacred Masculine" },
  { key: "Spiritual Leadership", label: "Spiritual Leadership" },
  { key: "Spiritual Mentoring", label: "Spiritual Mentoring" },
  { key: "Energy & Somatic Practices", label: "Energy & Somatic Practices" },
  { key: "Energy Coaching", label: "Energy Coaching" },
  { key: "Energy Work", label: "Energy Work" },
  { key: "Energy Healing", label: "Energy Healing" },
  { key: "Energy Medicine", label: "Energy Medicine" },
  { key: "Energetic Alignment", label: "Energetic Alignment" },
  { key: "Energetic Clearing", label: "Energetic Clearing" },
  { key: "Reiki", label: "Reiki" },
  { key: "Chakra Balancing", label: "Chakra Balancing" },
  { key: "Chakra Work", label: "Chakra Work" },
  { key: "Biofield Practices", label: "Biofield Practices" },
  { key: "Somatic Coaching", label: "Somatic Coaching" },
  { key: "Somatic Practices", label: "Somatic Practices" },
  { key: "Somatic Awareness", label: "Somatic Awareness" },
  { key: "Embodiment", label: "Embodiment" },
  { key: "Embodiment Coaching", label: "Embodiment Coaching" },
  { key: "Body Awareness", label: "Body Awareness" },
  { key: "Breathwork", label: "Breathwork" },
  { key: "Conscious Breathing", label: "Conscious Breathing" },
  { key: "Meditation", label: "Meditation" },
  { key: "Guided Meditation", label: "Guided Meditation" },
  { key: "Yoga", label: "Yoga" },
  { key: "Yoga Philosophy", label: "Yoga Philosophy" },
  { key: "Sound Healing", label: "Sound Healing" },
  { key: "Sound Bath", label: "Sound Bath" },
  { key: "Vibrational Practices", label: "Vibrational Practices" },
  { key: "Movement Meditation", label: "Movement Meditation" },
  { key: "Qi Gong", label: "Qi Gong" },
  { key: "Tai Chi", label: "Tai Chi" },
  { key: "Shamanic Practice", label: "Shamanic Practice" },
  { key: "Shamanic Coaching", label: "Shamanic Coaching" },
  { key: "Shamanic Healing", label: "Shamanic Healing" },
  { key: "Shamanic Journeying", label: "Shamanic Journeying" },
  { key: "Shamanic Breathwork", label: "Shamanic Breathwork" },
  { key: "Shamanic Energy Work", label: "Shamanic Energy Work" },
  { key: "Shamanic Ceremony", label: "Shamanic Ceremony" },
  { key: "Shamanic Wisdom", label: "Shamanic Wisdom" },
  { key: "Ancestral Practices", label: "Ancestral Practices" },
  { key: "Ancestral Healing", label: "Ancestral Healing" },
  { key: "Ancestral Wisdom", label: "Ancestral Wisdom" },
  { key: "Sacred Ceremony", label: "Sacred Ceremony" },
  { key: "Ritual", label: "Ritual" },
  { key: "Spiritual Ceremony", label: "Spiritual Ceremony" },
  { key: "Earth-Based Spirituality", label: "Earth-Based Spirituality" },
  { key: "Nature-Based Spirituality", label: "Nature-Based Spirituality" },
  { key: "Nature Connection", label: "Nature Connection" },
  { key: "Sacred Plant Traditions", label: "Sacred Plant Traditions" },
  { key: "Indigenous Wisdom", label: "Indigenous Wisdom" },
  { key: "Ayurveda", label: "Ayurveda" },
  { key: "Ayurvedic Lifestyle", label: "Ayurvedic Lifestyle" },
  { key: "Traditional Chinese Wellness", label: "Traditional Chinese Wellness" },
  { key: "Acupressure", label: "Acupressure" },
  { key: "Breath Therapy", label: "Breath Therapy" },
  { key: "Human Design", label: "Human Design" },
  { key: "Gene Keys", label: "Gene Keys" },
  { key: "Astrology", label: "Astrology" },
  { key: "Spiritual Astrology", label: "Spiritual Astrology" },
  { key: "Numerology", label: "Numerology" },
  { key: "Tarot", label: "Tarot" },
  { key: "Oracle Practices", label: "Oracle Practices" },
  { key: "Intuitive Reading", label: "Intuitive Reading" },
  { key: "Akashic Records", label: "Akashic Records" },
  { key: "Hypnotherapy", label: "Hypnotherapy" },
  { key: "Hypnosis", label: "Hypnosis" },
  { key: "NLP", label: "NLP" },
  { key: "Neuro-Linguistic Programming", label: "Neuro-Linguistic Programming" },
  { key: "EFT", label: "EFT" },
  { key: "Emotional Freedom Technique", label: "Emotional Freedom Technique" },
  { key: "Tapping", label: "Tapping" },
  { key: "Visualization", label: "Visualization" },
  { key: "Guided Imagery", label: "Guided Imagery" },
  { key: "Manifestation", label: "Manifestation" },
  { key: "Manifestation Coaching", label: "Manifestation Coaching" },
  { key: "Law of Attraction", label: "Law of Attraction" },
  { key: "Feng Shui", label: "Feng Shui" },
  { key: "Aromatherapy", label: "Aromatherapy" },
  { key: "Sound Therapy", label: "Sound Therapy" },
  { key: "Executive Retreat", label: "Executive Retreat" },
  { key: "Leadership Retreat", label: "Leadership Retreat" },
  { key: "Team Retreat", label: "Team Retreat" },
  { key: "Corporate Retreat", label: "Corporate Retreat" },
  { key: "Strategy Retreat", label: "Strategy Retreat" },
  { key: "Founder Retreat", label: "Founder Retreat" },
  { key: "Entrepreneur Retreat", label: "Entrepreneur Retreat" },
  { key: "Women's Retreat", label: "Women's Retreat" },
  { key: "Men's Retreat", label: "Men's Retreat" },
  { key: "Couples Retreat", label: "Couples Retreat" },
  { key: "Relationship Retreat", label: "Relationship Retreat" },
  { key: "Wellness Retreat", label: "Wellness Retreat" },
  { key: "Well-being Retreat", label: "Well-being Retreat" },
  { key: "Spiritual Retreat", label: "Spiritual Retreat" },
  { key: "Meditation Retreat", label: "Meditation Retreat" },
  { key: "Mindfulness Retreat", label: "Mindfulness Retreat" },
  { key: "Yoga Retreat", label: "Yoga Retreat" },
  { key: "Breathwork Retreat", label: "Breathwork Retreat" },
  { key: "Somatic Retreat", label: "Somatic Retreat" },
  { key: "Healing Retreat", label: "Healing Retreat" },
  { key: "Energy Retreat", label: "Energy Retreat" },
  { key: "Shamanic Retreat", label: "Shamanic Retreat" },
  { key: "Nature Retreat", label: "Nature Retreat" },
  { key: "Adventure Retreat", label: "Adventure Retreat" },
  { key: "Creativity Retreat", label: "Creativity Retreat" },
  { key: "Writing Retreat", label: "Writing Retreat" },
  { key: "Personal Development Retreat", label: "Personal Development Retreat" },
  { key: "Transformational Retreat", label: "Transformational Retreat" },
  { key: "Life Purpose Retreat", label: "Life Purpose Retreat" },
  { key: "Burnout Recovery Retreat", label: "Burnout Recovery Retreat" },
  { key: "Digital Detox Retreat", label: "Digital Detox Retreat" },
  { key: "Silent Retreat", label: "Silent Retreat" },
  { key: "Luxury Retreat", label: "Luxury Retreat" },
  { key: "Immersive Experience", label: "Immersive Experience" },
];

export const top_professional_services = [
  {
    key: 'Business',
    label: 'Business',
    image: Business1,
  },
  {
    key: 'Finance',
    label: 'Finance',
    image: Finance1,
  },
  {
    key: 'Leadership',
    label: 'Leadership',
    image: Leadership1,
  },
  {
    key: 'Health',
    label: 'Health',
    image: Health1,
  },
  {
    key: 'Marketing',
    label: 'Marketing',
    image: Marketing1,
  },
  {
    key: 'Motivation',
    label: 'Motivation',
    image: Motivation1,
  },
];

export const top_personal_services = [
  {
    key: 'Wellness',
    label: 'Wellness',
    image: Slide_Wellness,
  },
  {
    key: 'Transformational',
    label: 'Transformational',
    image: Slide_Transformational,
  },
  {
    key: 'Nutrition',
    label: 'Nutrition',
    image: Slide_Nutrition,
  },
  {
    key: 'Health',
    label: 'Health',
    image: Slide_Health,
  },
  {
    key: 'Marketing',
    label: 'Marketing',
    image: Slide_Marketing,
  },
  {
    key: 'Motivation',
    label: 'Motivation',
    image: Slide_Motivation,
  },
];

export const top_popular_services = [
  {
    key: 'Accounting',
    label: 'Accounting',
    image: Slide_Accounting,
  },
  {
    key: 'Confidence',
    label: 'Confidence',
    image: Slide_Confidence,
  },
  {
    key: 'Energy Work',
    label: 'Energy Work',
    image: Slide_Energy,
  },
  {
    key: 'Fitness',
    label: 'Fitness',
    image: Slide_Fitness,
  },
  {
    key: 'Inspiration',
    label: 'Inspiration',
    image: Slide_Inspiration,
  },
  {
    key: 'Nutrition',
    label: 'Nutrition',
    image: Slide_Nutrition,
  },
];

export const categories = [
  { key: 'smoke', label: 'Smoke' },
  { key: 'electric', label: 'Electric' },
  { key: 'wood', label: 'Wood' },
  { key: 'other', label: 'Other' },
];

export const experts = [
  { user_id: '5f0bff77-b42f-4119-b163-2a56fe408031', fullName: 'Jess Weiss', title: '' },
  { user_id: '5ed61360-eb68-4168-9b2e-1f0a57ada93a', fullName: 'Dr. Axel Meierhoefer', title: '' },
  { user_id: '5ed61360-9ed9-42ff-bf19-4cb9d975a1a1', fullName: 'Cynthia James', title: '' },
  { user_id: '5f7375ba-eb28-42db-a0fb-bbbc8263716a', fullName: 'Dave Mochel', title: '' },

  { user_id: '5ed61360-b40b-4063-962e-b59b307ce52a', fullName: 'Kelly Swingler', title: '' },
  { user_id: '5ed61360-4f03-4422-8792-9b65587498c2', fullName: 'Rajani Seshadri', title: '' },
  { user_id: '5ed61360-5313-49e2-9b69-bcba33f9d61c', fullName: 'Susie Carder', title: '' },
  { user_id: '5ed61360-b6a3-4d3a-973d-efe97c0dff73', fullName: 'Marion E. B', title: '' },
];

export const trustedBy = [
  { image: Icon_CoachLife },
  { image: Icon_Forbes },
  { image: Icon_Yahoo },
  { image: Icon_SBDC },
  { image: Icon_TATA },
  { image: Icon_LaunchFestival },
  { image: Icon_Startcon },
  { image: Icon_Engagement },
  { image: Icon_Motivation },
];

// Price filter configuration
// Note: unlike most prices this is not handled in subunits
export const priceFilterConfig = {
  min: 0,
  max: 1000,
  step: 5,
};

// Activate booking dates filter on search page
export const dateRangeFilterConfig = {
  active: true,
};

// Activate keyword filter on search page

// NOTE: If you are ordering search results by distance the keyword search can't be used at the same time.
// You can turn off ordering by distance in config.js file
export const keywordFilterConfig = {
  active: true,
};

// ----------------------------------------------------------------------------
// WebRTC peer connection config
//
// All TURN credentials are now driven by env vars so they can be rotated
// without a code change. The previous config hardcoded the IP and credentials
// in source; those values are public anyway (CRA inlines REACT_APP_* into the
// bundled JS) but env-var-driven config lets ops rotate creds, swap to a
// domain-name TURN endpoint, and run production and demo against different
// servers if needed.
//
// We fan a single TURN host out across three URLs so ICE can pick whichever
// transport works for the user's network:
//   1. turns:HOST:443       — TLS over TCP on the HTTPS port; traverses
//                              virtually any firewall, including ones that
//                              block UDP entirely.
//   2. turn:HOST:443?tcp    — plaintext TCP on 443; firewall fallback if the
//                              TLS handshake fails for some reason.
//   3. turn:HOST:3478       — standard UDP; lowest latency, used whenever the
//                              network allows it.
//
// Public Google STUN servers are kept as a final entry so that for the common
// case (both peers on networks that allow direct UDP) we don't need to relay
// through TURN at all, saving TURN bandwidth.
//
// Short-lived TURN credentials: when REACT_APP_TURN_DYNAMIC is enabled, the app
// fetches a per-call HMAC credential from coach-saas-service at call setup
// (see resolvePcConfig in webrtc.duck.js) instead of using the long-lived
// REACT_APP_TURN_CREDENTIAL baked into this bundle. Keep the flag OFF until
// coturn on turn.viveka.world is switched to `use-auth-secret` — otherwise the
// minted credential won't authenticate and relay candidates will silently fail.
// The static pcConfig below remains the fallback (flag off, or the mint
// endpoint unavailable). The REACT_APP_TURN_HOST/USERNAME/CREDENTIAL values are
// public; once dynamic creds are live, rotate the static credential out.
// ----------------------------------------------------------------------------

const turnHost = process.env.REACT_APP_TURN_HOST;
const turnUsername = process.env.REACT_APP_TURN_USERNAME;
const turnCredential = process.env.REACT_APP_TURN_CREDENTIAL;

// When true, fetch a short-lived TURN credential per call from the backend
// rather than shipping a long-lived one in this bundle.
export const turnDynamicEnabled = process.env.REACT_APP_TURN_DYNAMIC === 'true';

// A bare IP literal (IPv4 or bracketed/colon IPv6) can never satisfy TLS
// certificate validation for `turns:` — the browser has no hostname to match
// the cert against, so the TLS TURN URL is silently unusable and the relay
// path collapses to whatever plaintext `turn:` transport gets through. This
// is the exact misconfiguration that left only one browser/NAT pairing
// working. Detect it and (a) drop the unusable `turns:` URL so ICE doesn't
// waste time on a candidate that can't form, (b) warn loudly so the infra
// owner knows DNS + a cert are still required for firewall-tight networks.
const isIpLiteral =
  !!turnHost &&
  (/^\d{1,3}(\.\d{1,3}){3}$/.test(turnHost) || turnHost.indexOf(':') !== -1);

// Ordered list of TURN relay URLs for the configured host. Shared by the static
// credential path and the dynamic (minted) credential path so transport
// ordering and IP-literal handling stay identical between them.
function buildTurnUrls() {
  const turnUrls = [
    `turn:${turnHost}:443?transport=tcp`,
    `turn:${turnHost}:3478`,
  ];
  if (!isIpLiteral) {
    // Only meaningful with a real hostname that has a valid TLS cert. Put it
    // first so ICE prefers the most firewall-traversal-friendly transport.
    turnUrls.unshift(`turns:${turnHost}:443`);
  } else if (typeof console !== 'undefined') {
    // eslint-disable-next-line no-console
    console.warn(
      '[webrtc] REACT_APP_TURN_HOST is a bare IP (' +
        turnHost +
        '). The TLS `turns:` relay URL has been dropped because cert ' +
        'validation cannot succeed against an IP. Plaintext turn: TCP/UDP ' +
        'relay will still be attempted, but networks that block both UDP ' +
        'and plaintext TCP TURN will fail. Point REACT_APP_TURN_HOST at a ' +
        'DNS name with a valid TLS certificate to fully fix this.'
    );
  }
  return turnUrls;
}

const STUN_SERVER = {
  urls: ['stun:stun.l.google.com:19302', 'stun:stun1.l.google.com:19302'],
};

// RTCConfiguration options shared by the static and dynamic configs.
const PC_OPTIONS = {
  // 'all' lets ICE use host, srflx (STUN), and relay (TURN) candidates. Set to
  // 'relay' temporarily when debugging whether TURN is reachable at all — that
  // forces TURN-only and isolates "is the relay path working?" from "is direct
  // P2P working?".
  iceTransportPolicy: 'all',
  // bundlePolicy: 'max-bundle' was set here as a minor optimisation but was
  // reverted after a symmetric "see-myself-not-them" media failure on demo
  // shortly after deploy. The default ('balanced') is what the WebRTC code
  // worked with for years; restore it until we have a reliable repro that
  // proves max-bundle is safe in our exact offer/answer flow.
};

// Build an RTCConfiguration from an explicit, freshly-minted TURN
// username/credential pair (the dynamic path). Falls back to STUN-only if the
// TURN host isn't configured.
export function buildPcConfig({ username, credential } = {}) {
  const iceServers = [];
  if (turnHost && username && credential) {
    iceServers.push({ urls: buildTurnUrls(), username, credential });
  }
  iceServers.push(STUN_SERVER);
  return { iceServers, ...PC_OPTIONS };
}

// Static credential path (default / fallback). Unchanged behaviour: TURN entry
// only when all three REACT_APP_TURN_* vars are present, else STUN-only with a
// loud warning.
const iceServers = [];

if (turnHost && turnUsername && turnCredential) {
  iceServers.push({
    urls: buildTurnUrls(),
    username: turnUsername,
    credential: turnCredential,
  });
} else if (typeof console !== 'undefined') {
  // eslint-disable-next-line no-console
  console.warn(
    '[webrtc] TURN env vars are missing — built-in video calls will fall back ' +
      'to STUN-only and may not connect for users behind symmetric NAT or ' +
      'restrictive firewalls. Set REACT_APP_TURN_HOST, REACT_APP_TURN_USERNAME, ' +
      'REACT_APP_TURN_CREDENTIAL.'
  );
}

iceServers.push(STUN_SERVER);

export const pcConfig = {
  iceServers,
  ...PC_OPTIONS,
};
